module.exports = __webpack_public_path__ + "img/us-flag.23a3fd91.svg";